import React from 'react';
import ReactDOM from 'react-dom/client';
import './css/index.css';
import Home from './components/Home';
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import reportWebVitals from './reportWebVitals';





import About from './components/About';
import Shop from './components/Shop';
import ProductPage from './components/ProductPage';
import Account from './components/Account';
import { PortfolioPage as Portfolio } from './studio/PortfolioPage';
import StorefrontLayout from './components/StorefrontLayout';
import './studio/live.css';
import Events from './components/Events';

import { CartProvider } from './cartContext';
import { CatalogProvider } from './catalogContext';
import { AccountProvider } from './accountContext';

import Admin from './components/Admin';


import ReactGA from 'react-ga';
const TRACKING_ID = "UA-XXXXX-X"; // OUR_TRACKING_ID
ReactGA.initialize(TRACKING_ID);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Router>
      <CatalogProvider>
      <AccountProvider>
      <CartProvider>
        <Routes>
        <Route path="/" element={<Home/>} />
        <Route path="/shop" element={<Shop/>} />
        <Route path="/products/:id" element={<ProductPage/>} />
        <Route path="/portfolio" element={<StorefrontLayout><main className="ds-app"><Portfolio/></main></StorefrontLayout>} />
        <Route path="/events" element={<Events/>} />
        <Route path="/about" element={<About/>} />
        <Route path="/account" element={<Account/>} />
        <Route path="/admin" element={<Admin/>} />
        <Route path="/lithographs" element={<Navigate to="/portfolio?medium=Lithography" replace />} />
        <Route path="/screenprints" element={<Navigate to="/portfolio?medium=Screenprint" replace />} />
        <Route path="/intaglio" element={<Navigate to="/portfolio?medium=Intaglio" replace />} />
        <Route path="/reliefprints" element={<Navigate to="/portfolio?medium=Relief" replace />} />
        <Route path="/ecoprints" element={<Navigate to="/portfolio?medium=Eco%20Print" replace />} />
        </Routes>
      </CartProvider>
      </AccountProvider>
      </CatalogProvider>
    </Router>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
